module.exports = __webpack_public_path__ + "img/arrow-back.cd420eab.svg";